export const PAYMENT_METHODS = [
  'Selecciona una opción',
  'Efectivo',
  'Mercado pago',
  'Transferencia',
];
